import { c as _c } from "react/compiler-runtime";
import React, { FC, SVGProps } from 'react';
import { isPresent } from '../../farmai-shared/LFUtils';
export const RatingTileIcon: FC<SVGProps<SVGSVGElement>> = props => {
  const $ = _c(2);
  if (!props) {
    return null;
  }
  let t0;
  if ($[0] !== props) {
    const colors = {
      damage: {
        start: "#BF4A49",
        end: "#AA4469"
      },
      poor: {
        start: "#EC7546",
        end: "#DA5C6F"
      },
      average: {
        start: "#B39A41",
        end: "#76934A"
      },
      good: {
        start: "#70D282",
        end: "#31B88F"
      },
      excellent: {
        start: "#219D78",
        end: "#008D7F"
      },
      none: {
        start: "#BFC7E1",
        end: "#727D9F"
      }
    }[props?.name || "none"] || null;
    t0 = isPresent(colors) ? <svg {...props} viewBox="0 0 45 26" fill="current" xmlns="http://www.w3.org/2000/svg"><path d="M43.6654 11.225L23.2323 0.271018C22.5591 -0.0903394 21.4694 -0.0903394 20.8005 0.271018L0.499896 11.225C-0.169076 11.5864 -0.166972 12.1724 0.508311 12.5337L20.9414 23.4878C21.6146 23.8491 22.7043 23.8491 23.3733 23.4878L43.6738 12.5337C44.3428 12.1704 44.3386 11.5844 43.6654 11.225Z" fill={`url(#paint0_linear_5544_144385_${props?.name || "none"})`} /><path d="M43.6723 12.0844L23.3738 23.2061C22.7049 23.573 21.6153 23.573 20.9422 23.2061L0.513248 12.0844C0.174588 11.8999 0.00420695 11.658 0.00631042 11.416L0 13.7223C0 13.9643 0.168278 14.2062 0.506937 14.3907L20.938 25.5124C21.6111 25.8793 22.7007 25.8793 23.3696 25.5124L43.6681 14.3907C44.0005 14.2082 44.1666 13.9702 44.1687 13.7322L44.173 11.4259C44.173 11.6639 44.0068 11.9019 43.6723 12.0844Z" fill="#BFC7E1" /><defs><linearGradient id={`paint0_linear_5544_144385_${props?.name || "none"}`} x1="28.2957" y1="8.36372" x2="-48.0769" y2="40.3765" gradientUnits="userSpaceOnUse"><stop stopColor={colors.start} /><stop offset="1" stopColor={colors.end} /></linearGradient></defs></svg> : null;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};